import style from "./style.module.scss";
import useFormat from "../../hooks/utils/useFormat";
import { useNavigate } from "react-router-dom";

// Sufixo pequeno "(Convites: X · Ingressos: Y)" pra um evento que tem Base configurada NESTE
// orçamento — só a quantidade, igual ao "(N formandos)" já usado aqui pros pacotes/avulsos.
// Convites/Ingressos ficam atrelados ao orçamento (budgetColectionEventInvite) enquanto ainda é
// rascunho, não à turma — cada orçamento pode ter sua própria Base pro mesmo evento.
function buildInviteSuffix(budgetColectionEventInvite, event_id) {
  const _invite = budgetColectionEventInvite?.find(__invite => __invite.event_id === event_id);
  if (!_invite) return "";

  const _parts = [];
  if (_invite.qtd_invitations != null) _parts.push(`Convites: ${_invite.qtd_invitations}`);
  if (_invite.qtd_tickets != null) _parts.push(`Ingressos: ${_invite.qtd_tickets}`);
  return _parts.length > 0 ? ` (${_parts.join(" · ")})` : "";
}

export default function BudgetsList(props) {
  const { formatDate } = useFormat();
  const navigate = useNavigate();
  const { budgets } = props;
  return (
    <div className={style.budget_list} {...props}>
      {budgets
        ?.filter(__budget => !!__budget.active)
        ?.map(__budget => (
          <div
            className={`${style.budget_item} ${!!__budget.main ? style.budget_main : ""}`}
            onClick={() => {
              navigate(`/business/budget/${__budget.commercial_id}/${__budget.id}`);
            }}
          >
            <p className={`${style.budget_title} d-flex justify-content-between m-0`}>
              <b>{__budget.title || ""}</b>
              {!!__budget.main ? <span>(Principal)</span> : ""}
            </p>
            <p className="op-5">{__budget?.description || ""}</p>
            {__budget?.packageColection?.length > 0 && (
              <>
                <p className="mt-2">
                  <b>Pacotes:</b>
                </p>
                {__budget?.packageColection
                  ?.filter(__package => !!__package.active)
                  ?.map(__package => (
                    <p className={style.budget_package}>
                      <b>{__package.title || ""}</b>
                      <span className="small-label">{` (${__package.number_trainees} formandos)`}</span>:
                      {__package?.events?.map((__event, __event_i) => (
                        <span>
                          {__event_i > 0 ? ", " : " "}
                          {__event.name}
                          <span className="small-label">
                            {buildInviteSuffix(__budget.budgetColectionEventInvite, __event.id)}
                          </span>
                        </span>
                      ))}
                    </p>
                  ))}
              </>
            )}
            {__budget?.packageSingleColection?.length > 0 && (
              <>
                <p>
                  <b>Avulsos:</b>
                </p>
                {__budget?.packageSingleColection
                  ?.filter(__single => !!__single.active)
                  ?.map(__single => (
                    <p className={style.budget_package}>
                      <b>{__single?.events?.name || ""}</b>
                      <span className="small-label">
                        {` (${__single.number_trainees} formandos)`}
                        {buildInviteSuffix(__budget.budgetColectionEventInvite, __single?.events?.id)}
                      </span>
                    </p>
                  ))}
              </>
            )}
            <p className="small-label mt-2">{formatDate(__budget.updated_at, 1)}</p>
          </div>
        ))}
    </div>
  );
}
